.bo{right:0px;}